<template>

    <div>

        <!-- page header -->
        <page-heading :show="true" pageTitle="CATALOG-ONLINE-LEXICON"></page-heading>

    	<!-- show loading indicator -->
    	<loading-indicator :loading="isLoading"></loading-indicator>

    	<template v-if="!isLoading">

			<div class="columns">

				<div class="col-main">

                    <div class="box">

                        <div class="inner">

                            <label-name labelKey="LEXICON-SELECT-BODY_PART"></label-name>
                            <multiselect
                                v-model="bodyPart"
                                track-by="id"
                                label="name"
                                :options="bodyParts.anatomicalAtlasEntry"
                                placeholder="Körperteil wählen"
                                :allowEmpty="false"
                                :show-labels="false"
                                :searchable="true"
                                :class="singleSelect"
                                @select="onSelect">

                                <!--
                                <template slot="option" slot-scope="props">
                                    <span :class="'option__title '+props.option.name">{{ $t(label + props.option.name) }}</span>
                                </template>
                                -->

                            </multiselect>

                        </div>

                        <loading-indicator :loading="isLoadingBodyPart"></loading-indicator>

                        <template v-if="!isLoadingBodyPart && bodyPart != null">

                            <div class="grey">

                                <div class="inner">

                                    <!-- NAME -->
                                    <form-input inputType="text" label="LEXICON-NAME" v-model="bodyPart.name"></form-input>

                                    <!-- FRIENDLY URL -->
                                    <form-input inputType="text" label="LEXICON-FRIENDLY_NAME" v-model="friendlyName"></form-input>

                                </div>

                            </div>

                            <div class="inner">

                                <!-- PRODUKTE TOP -->
                                <div class="control">
                                    <div class="control-label">
                                        <label-name labelKey="LEXICON-PRODUCTS_TOP"></label-name>
                                    </div>
                                    <div class="control">

                                        <multiselect
                                            v-model="productsTop"
                                            :multiple="true"
                                            :searchable="true"
                                            track-by="id"
                                            label="name"
                                            :loading="isProductsLoading"
                                            :internal-search="false"
                                            :clear-on-select="true"
                                            :close-on-select="true"
                                            :options="products"
                                            :options-limit="10"
                                            :limit="2"
                                            :max="2"
                                            limit-text="limitText"
                                            :show-no-results="true"
                                            :hide-selected="true"
                                            selectLabel="Enter um Produkt auszuwählen"
                                            tagPlaceholder="Enter um Produkt auszuwählen"
                                            placeholder="Produkte suchen/wählen"
                                            @search-change="asyncFindProducts">

                                            <span slot="noOptions">Suchbegriff eingeben</span>
                                            <span slot="noResult">Für diesen Suchbegriff konnten keine Beiträge gefunden werden.</span>
                                            <span slot="maxElements">Sie können maximal 2 Produkte zuordnen.</span>

                                            <template slot="option" slot-scope="props">
                                                <img class="option__image" v-lazy="getOptionImage(props.option.productAssets)" :alt="props.option.name">
                                                <div class="option__desc">
                                                    <span class="option__title">{{ props.option.name }}</span>
                                                </div>
                                            </template>

                                            <template slot="selection" slot-scope="{ values, search, isOpen }">
                                                <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">
                                                    {{ values.length }}
                                                    <template v-if="values.length == 1">Produkt </template>
                                                    <template v-else>Produkte </template>
                                                    zugeordnet
                                                </span>
                                            </template>

                                        </multiselect>


                                        <div class="productsContainer" v-if="productsTop.length > 0">

                                            <div v-for="product in productsTop" class="lexiconProduct">
                                                <div class="image">
                                                    <img v-lazy="getOptionImage(product.productAssets)" />
                                                </div>
                                                <div class="name">
                                                    {{ product.name }}
                                                </div>

                                                <span class="removeProduct" @click="remove(productsTop, product)" title="Produkt entfernen">
                                                    <span class="icon is-small"><i class="icon-ak-entfernen"></i></span>
                                                </span>

                                            </div>

                                        </div>

                                    </div>

                                </div>




                                <!-- HEADLINE -->
                                <form-input inputType="text" label="LEXICON-HEADLINE" v-model="bodyPart.headline"></form-input>

                                <!-- CONTENT -->
                                <div class="control">
                                    <div class="control-label">
                                        <label-name labelKey="LEXICON-CONTENT"></label-name>
                                    </div>
                                    <div class="control">
                                        <froala :tag="'textarea'" :config="froalaConfig" v-model="bodyPart.content"></froala>
                                    </div>
                                </div>

                                <!-- FACTS -->
                                <div class="control">
                                    <div class="control-label">
                                        <label-name labelKey="LEXICON-FACTS"></label-name>
                                    </div>
                                    <div class="control">
                                        <froala :tag="'textarea'" :config="froalaConfig2" v-model="bodyPart.facts"></froala>
                                    </div>
                                </div>

                                <!-- SUMMARY -->
                                <div class="control">
                                    <div class="control-label">
                                        <label-name labelKey="LEXICON-SUMMARY"></label-name>
                                    </div>
                                    <div class="control">
                                        <froala :tag="'textarea'" :config="froalaConfig2" v-model="bodyPart.summary"></froala>
                                    </div>
                                </div>



                                <!-- PRODUKTE BOTTOM -->
                                <div class="control">
                                    <div class="control-label">
                                        <label-name labelKey="LEXICON-PRODUCTS_BOTTOM"></label-name>
                                    </div>
                                    <div class="control">

                                        <multiselect
                                            v-model="productsBottom"
                                            :multiple="true"
                                            :searchable="true"
                                            track-by="id"
                                            label="name"
                                            :loading="isProductsLoading"
                                            :internal-search="false"
                                            :clear-on-select="true"
                                            :close-on-select="true"
                                            :options="products"
                                            :options-limit="10"
                                            :limit="25"
                                            :max="10"
                                            limit-text="limitText"
                                            :show-no-results="true"
                                            :hide-selected="true"
                                            selectLabel="Enter um Produkt auszuwählen"
                                            tagPlaceholder="Enter um Produkt auszuwählen"
                                            placeholder="Produkte suchen/wählen"
                                            @search-change="asyncFindProducts">

                                            <span slot="noOptions">Suchbegriff eingeben</span>
                                            <span slot="noResult">Für diesen Suchbegriff konnten keine Beiträge gefunden werden.</span>

                                            <template slot="option" slot-scope="props">

                                                <img class="option__image" v-lazy="getOptionImage(props.option.productAssets)" :alt="props.option.name" :key="props.option.id">
                                                <div class="option__desc">
                                                    <span class="option__title">{{ props.option.name }}</span>
                                                </div>

                                            </template>

                                            <template slot="selection" slot-scope="{ values, search, isOpen }">
                                                <span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">
                                                    {{ values.length }}
                                                    <template v-if="values.length == 1">Produkt </template>
                                                    <template v-else>Produkte </template>
                                                    zugeordnet
                                                </span>
                                            </template>

                                        </multiselect>


                                        <div class="productsContainer" v-if="productsBottom.length > 0">

                                            <div v-for="product in productsBottom" class="lexiconProduct">
                                                <div class="image">
                                                    <img v-lazy="getOptionImage(product.productAssets)" />
                                                </div>
                                                <div class="name">
                                                    {{ product.name }}
                                                </div>
                                                <span class="removeProduct" @click="remove(productsBottom, product)" title="Produkt entfernen">
                                                    <span class="icon is-small"><i class="icon-ak-entfernen"></i></span>
                                                </span>
                                            </div>

                                        </div>

                                    </div>
                                </div>

                                <div class="has-text-centered">
                                    <custom-button type="blue" icon="icon-ak-speichern" name="LEXICON-BTN-SAVE" :loading="isSaving" @click.native="save"></custom-button>
                                </div>

                            </div>

                        </template>


                    </div>

                </div>

            </div>


        </template>

    </div>

</template>

<script>
import Multiselect from 'vue-multiselect';

// Require Froala Editor js and css files
require('froala-editor/js/froala_editor.pkgd.min')
require('froala-editor/js/languages/de.js')
require('froala-editor/css/froala_editor.pkgd.min.css')
require('froala-editor/css/froala_style.min.css')

import Vue from 'vue';
import VueFroala from 'vue-froala-wysiwyg';
Vue.use(VueFroala)


export default {

	name: 'catalogOnlineLexicon',

    components: {
        Multiselect
    },

    data() {

		return {

            isLoading: false,
            isLoadingBodyPart: false,
            isSaving: false,
            bodyParts: [],
            bodyPart: null,
            productsTop: [],
            productsBottom: [],

            products: [],
            isProductsLoading: false,

            /*
            bodyPart: {
                name: '',
                friendlyName: null,
                headline: '',
                content: '',
                facts: '',
                summary: '',
            },
            */


            froalaConfig: {
                key: '',
                toolbarButtons: ['bold', 'italic', 'underline', '|', 'subscript', 'superscript', '|', 'paragraphFormat', 'formatOL', 'formatUL', '|', 'outdent', 'indent', '|', 'undo', 'redo'],
                placeholderText: 'Schreiben Sie hier Ihren Text ...',
                imageEditButtons: [],
                paragraphFormat: {
                    N: 'Normal',
                    H3: 'Heading 3',
                    H4: 'Heading 4'
                },
                charCounterCount: false,
                pastePlain: true,
                initOnClick: false,
                requestHeaders: {
					"Authorization": 'Basic ' + localStorage.getItem('token')
			  	},
                quickInsertButtons: [],
                language: 'de',
            },
            froalaConfig2: {
                key: '',
                toolbarButtons: ['bold', 'italic', 'underline', '|', 'subscript', 'superscript', '|', 'formatOL', 'formatUL', '|', 'undo', 'redo'],
                placeholderText: 'Schreiben Sie hier Ihren Text ...',
                imageEditButtons: [],
                quickInsertTags: [],
                charCounterCount: false,
                pastePlain: true,
                initOnClick: false,
                requestHeaders: {
					"Authorization": 'Basic ' + localStorage.getItem('token')
			  	},
                language: 'de',
            },
        }
    },


    created() {

        // set licence key for froala
    	this.froalaConfig.key = this.$config.froalaKey;
        this.froalaConfig2.key = this.$config.froalaKey;

        this.fetchData();

    },

    watch: {


        /*
        'bodyPart'(val) {

            console.log("products: ", val.products);

            if(val.products.length > 0) {

                // console.log(val.products);
                this.productsTop = [];
                this.productsBottom = [];

                val.products.forEach(p => {

                    if(p.product != null) {

                        if(p.product.position == 'top') {

                            this.productsTop.push(p.product);

                        } else {

                            this.productsBottom.push(p.product);

                        }
                    }

                })


            }

        }
        */



    },


    computed: {

        friendlyName: {
            set(val) {
                this.bodyPart.friendlyName = this.slugify(val);
            },

            get() {
                return this.bodyPart.friendlyName
            }
        }

    },

    methods: {

        remove(model, product) {

            let index = model.findIndex(_ => _.id == product.id);
            model.splice(index, 1);

        },

        getOptionImage(assets) {

            let asset = assets[0];
            if(typeof asset != 'undefined') {
                return this.$config.assets + asset.asset.path + '/200/' + asset.asset.filename;
            }

        },

        fetchData() {

            this.isLoading = true;
            var self = this;

            let url = this.$config.api + 'anatomicalAtlasEntry?orderBy=name';

            this.axios.get(url).then(response => {
                self.bodyParts = response.data;
                self.isLoading = false;
            })

        },

        fetchBodyPart(id) {

            this.isLoadingBodyPart = true;

            var self = this;

            let url = this.$config.api + 'anatomicalAtlasEntry?include=anatomicalAtlasEntry.products,anatomicalAtlasEntryProduct.product,product.productVariants,productVariant.voucher,product.productVouchers,product.productAssets,productAsset.asset&filters[id]='+id;

            this.axios.get(url).then(response => {

                self.bodyPart = response.data.anatomicalAtlasEntry[0];
                self.productsTop = [];
                self.productsBottom = [];

                if(self.bodyPart.products.length > 0) {

                    self.bodyPart.products.forEach(p => {

                        if(p.product != null) {

                            if(p.position == 'top') {
                                self.productsTop.push(p.product);
                            } else {
                                self.productsBottom.push(p.product);
                            }
                        }

                    })

                }

                self.isLoadingBodyPart = false;

            })

        },



        asyncFindProducts(query) {

            this.isProductsLoading = true

            var self = this;

            this.axios.get(this.$config.api + 'product/search?q='+query).then(response => {
                self.products = response.data.product;
                self.isProductsLoading = false;
            });

        },

        limitText (count) {

            return `und ${count} weitere Produkte`

        },

        slugify(string) {

            const a = 'àáäâãåăæçèéëêǵḧìíïîḿńǹñòóöôœṕŕßśșțùúüûǘẃẍÿź·/_,:;'
            const b = 'aaaaaaaaceeeeghiiiimnnnoooooprssstuuuuuwxyz------'
            const p = new RegExp(a.split('').join('|'), 'g')
            return string.toString().toLowerCase()
                .replace(/\s+/g, '-') // Replace spaces with -
                .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
                .replace(/&/g, '-and-') // Replace & with ‘and’
                .replace(/[^\w\-]+/g, '') // Remove all non-word characters
                .replace(/\-\-+/g, '-') // Replace multiple - with single -
                .replace(/^-+/, '') // Trim - from start of text
                .replace(/-+$/, '') // Trim - from end of text

        },

        save() {

            var err = null;
            this.isSaving = true;

            if(this.bodyPart.name == "") {
                this.$notify.open({ content: 'Bitte geben Sie einen Namen ein!', type: 'warning' });
                return false;
            }
            else if(this.bodyPart.friendlyName == "") {
                this.$notify.open({ content: 'Bitte geben Sie einen Namen für die URL ein!', type: 'warning' });
                return false;
            }
            else if(this.bodyPart.headline == "") {
                this.$notify.open({ content: 'Bitte geben Sie eine Überschrift ein!', type: 'warning' });
                return false;
            }
            else if(this.bodyPart.content == "") {
                this.$notify.open({ content: 'Bitte geben Sie einen Inhalt ein!', type: 'warning' });
                return false;
            }
            else if(this.bodyPart.summary == "") {
                this.$notify.open({ content: 'Bitte geben Sie einen Text für "Kurz und Knapp" ein!', type: 'warning' });
                return false;
            }
            else if(this.bodyPart.facts == "") {
                this.$notify.open({ content: 'Bitte geben Sie einen Text für "10 Zahlen" ein!', type: 'warning' });
                return false;
            }

            var self = this;


            this.bodyPart.products = [];

            this.productsTop.forEach(p => {

                console.log("p: ", p);
                self.bodyPart.products.push({
                    product: p.id,
                    anatomicalAtlasEntry: this.bodyPart.id,
                    sortorder: 0,
                    position: 'top',
                })

            })

            this.productsBottom.forEach(p => {

                console.log("p: ", p);

                self.bodyPart.products.push({
                    product: p.id,
                    anatomicalAtlasEntry: this.bodyPart.id,
                    sortorder: 0,
                    position: 'bottom',
                })

            })


            this.axios.put(this.$config.api + 'anatomicalAtlasEntry/'+this.bodyPart.id, this.bodyPart)
                .then(response => {
                    self.isSaving = false;
                    self.$notify.open({'content': 'Eintrag wurde erfolgreich gespeichert!', type: 'success'});
                });


            /*
            anatomicalAtlasEntry: { products:
                [
                    { product: 1, anatomicalAtlasEntry: 3, sortorder: 0, position: 'top' }
                ]
            }
            */


        },

        onSelect(option) {

            // console.log("onSelect: ", option);
            this.fetchBodyPart(option.id);

        }

    }

}


</script>

<style scoped>

    .grey {
        background: #f5f5f5;
        padding: 15px 0;
        margin: 25px -25px 20px -25px;
    }
    .inner {
        max-width: 768px;
        margin: 0 auto;
    }

    >>> .control > .control {
        max-width: 100%;
    }

    .productsContainer {
        margin: 25px 0;
    }
    .lexiconProduct {
        position: relative;
        display: flex;
        width: 100%;
        height: 65px;
        background: #f8f8f8;
        padding: 15px 5px;
    }
    .lexiconProduct:not(:last-child) {
        margin-bottom: 5px;
    }
    .lexiconProduct .image {
        flex: 0;
        flex-basis: 100px;
    }
    .lexiconProduct .image img {
        object-fit: contain;
        width: 100px;
        height: 100%;
    }
    .lexiconProduct .removeProduct {
        position: absolute;
        right: 5px;
        top: 6px;
        height: 18px;
        width: 18px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        color: #aaa;
        transition: color .3s ease;
    }
    .lexiconProduct .removeProduct:hover {
        color: #222;
    }
    .lexiconProduct .removeProduct .icon {
        height: 14px;
        width: 14px;
    }
    >>> .fr-toolbar {
        border-top: none;
    }

    >>> .fr-view h3,
    >>> .fr-view h4 {
        font-weight: bold;
        font-size: 14px;
        margin-bottom: 5px;
    }

    >>> .fr-view h3 {
        font-size: 16px;
        margin-bottom: 8px;
    }
    >>> .fr-view ol,
    >>> .fr-view ul {
        margin-bottom: 20px;
    }

    >>> .multiselect__option {
        display: flex;
        max-height: 50px;
    }
    >>> .multiselect__option .option__image {
        flex-basis: 70px;
        object-fit: contain;
        width: 50px;
        height: auto;
    }
    >>> .multiselect__option .option__desc {
        font-size: 12px;
    }

</style>
